module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEJSURBVEiJ7ZK9SsRAFIXPiDGFYL2llS9g5ztY+Qy5EwJZFB/AYKOgjWRTmJ/GtGvnI4iFYGej2FmksrBYwkC412obWXZ2dkm1+7X33PPNhQE2rDdENA7DcH+Vji3L/ISZP4noLo7jvT4EAOABGBpjPrTWlCTJIjtOgikDEblvmuY1CIKjPgQAABE5VEo9E9FDFEUDW17NGxKRWPYnAG59379K09TMCjhf8I9dABfGmHet9XEfginbzLzTh+BXRE4BHBRF8TjTvGQxAxh5nneZZdnPvOAyghdmHpZl+bZI2EXwDeA8z/MxANvvchIYANdt297UdT1xeJBdoJR66rrurKqqL9fiDWvEHwSaV4CutlgsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icons8-play-24.png
// module id = 914
// module chunks = 1